import { render, staticRenderFns } from "./Promocodes.vue?vue&type=template&id=14826835&"
import script from "./Promocodes.vue?vue&type=script&lang=js&"
export * from "./Promocodes.vue?vue&type=script&lang=js&"
import style0 from "./Promocodes.vue?vue&type=style&index=0&id=14826835&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports